import caseNumberIcon from "../../assets/age-assessment/icons/caseNumberIcon.svg";
import caseIcon from "../../assets/age-assessment/icons/caseIcon.svg";
import caseStar from "../../assets/age-assessment/icons/caseStar.svg";
import opg from "../../assets/age-assessment/icons/opg.svg";
import remove from "../../assets/age-assessment/icons/remove.svg";
import zoom from "../../assets/age-assessment/icons/zoom.svg";
import opgImage from "../../assets/age-assessment/icons/opg.svg";
import addfill from "../../assets/age-assessment/icons/addfill.svg";
import diagram from "../../assets/age-assessment/icons/diagram.svg";
import radiograph from "../../assets/age-assessment/icons/radiograph.svg";
import zoomIn from "../../assets/age-assessment/icons/zoomIn.svg";
import zoomOut from "../../assets/age-assessment/icons/zoomOut.svg";
import fullView from "../../assets/age-assessment/icons/fullView.svg";
import leftArrow from "../../assets/age-assessment/icons/leftArrow.svg";
import rightArrow from "../../assets/age-assessment/icons/rightArrow.svg";
import rotate from "../../assets/age-assessment/icons/rotate.svg";
import cancel from "../../assets/age-assessment/icons/cancel.svg";
import proceed from "../../assets/age-assessment/icons/proceed.svg";
import tickMark from "../../assets/age-assessment/icons/tickMark.svg";
import noresult from "../../assets/age-assessment/icons/noresult.svg";
import conductingIcon from "../../assets/age-assessment/icons/conductingIcon.svg";
import aboutUsIcon from "../../assets/dental-inden/icons/aboutUsIcon.svg";

import radiograph1 from "../../assets/age-assessment/images/radiograph1.png";
import radiograph2 from "../../assets/age-assessment/images/radiograph2.png";
import partner1 from "../../assets/age-assessment/images/partner1.png";
import partner2 from "../../assets/age-assessment/images/partner2.png";
import partner3 from "../../assets/age-assessment/images/partner3.png";
import opgA from "../../assets/age-assessment/images/opg.png";
import homeBanner from "../../assets/age-assessment/images/home-banner.png";

export const assessmentIcons = {
  caseNumberIcon,
  caseIcon,
  caseStar,
  opg,
  opgImage,
  radiograph1,
  radiograph2,
  remove,
  zoom,
  partner1,
  partner2,
  partner3,
  addfill,
  diagram,
  radiograph,
  zoomIn,
  zoomOut,
  fullView,
  leftArrow,
  rightArrow,
  opgA,
  rotate,
  cancel,
  proceed,
  tickMark,
  noresult,
  homeBanner,
  conductingIcon,
  aboutUsIcon,
};
